import { render, staticRenderFns } from "./SchoolYearSwitcher.vue?vue&type=template&id=73ee9bb2&"
import script from "./SchoolYearSwitcher.vue?vue&type=script&lang=js&"
export * from "./SchoolYearSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports